import { INavigationItem } from '../core/models/navigation/INavigationItem';
import { EHomeItems } from '../features/shared/enums/EHomeItems';

export const NavigationItems: INavigationItem[] = [
	EHomeItems.LectureVitale,
	EHomeItems.Patients,
	EHomeItems.Ordonnances,
	EHomeItems.Transmissions,
	EHomeItems.Tournees,
	EHomeItems.Planning,
	EHomeItems.Contacts,
	EHomeItems.Facturation,
	EHomeItems.Teletransmission,
	EHomeItems.SuiviFacturation,
	EHomeItems.Retrocession,
	EHomeItems.Parametres,
];